export default {
    ID: "1",
    SLUG: "enabill",
    NAME: "Enabill",
    PRIMARY: "#eb5b5e",
    SECONDARY: "#df2124",
    API: "https://api.enabill.com",
    LOGO: "/enabill/logo.png",
    APP_ICON: "/assets/enabill/icon.png",
    APP_LOGO: "/assets/enabill/logo.png",
    APP_FAVICON: "/assets/enabill/favicon.ico",
    APP_NAME: "Enabill",
  };